//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/system/apiManage/index';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      rules: {
        interfaceName: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        interfaceUrl: [{
          required: true,
          message: '请输入接口地址',
          trigger: 'blur'
        }, {
          min: 1,
          max: 200,
          message: '长度在 1 到 200 个字符',
          trigger: 'change'
        }]
      },
      posId: 0,
      childData: {
        interfaceName: '',
        interfaceUrl: ''
      }
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.postId = 0;
        this.childData = {
          interfaceName: '',
          interfaceUrl: ''
        };
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};